export enum BuilderTypes {
  MIDJOURNEY = 'MIDJOURNEY',
  DALL_E_2 = 'DALL_E_2',
  STABILITYAI = 'STABILITYAI',
}

export const BuilderTypes_Array = Object.values(BuilderTypes);
